import bindAllOfThis from 'src/utils/BindThisHelper';
import { EndGameScene } from './EndGameScene';
import { TiledGameObject } from 'src/games/shared/phaserHelpers/HandyTypes';
import { Fossil } from '../objects/Fossil';

export class MainScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    map: Phaser.Tilemaps.Tilemap;

    fossils: Fossil[];
    brushCursor: string;

    constructor() {
        super({
            key: "MainScene"
        });
    }

    preload(): void {
        this.load.tilemapTiledJSON("map", require("src/assets/qci/maps/fossil_finder.json"));
        this.load.image("background", require("src/assets/qci/backgrounds/pki_background.png"));
        this.load.atlas("assets", require("src/assets/qci/atlas/gameFossilFinder.png"), require("src/assets/qci/atlas/gameFossilFinder.json"));
        this.brushCursor = 'url(' + require("/src/assets/qci/sprites/cursors/fossil_brush.cur") + '), pointer';
    }

    initialize() {
        bindAllOfThis(this, MainScene.prototype);
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: "map" });
        this.fossils = [];
    }

    create(): void {
        this.initialize();
        var background = this.add.image(0, 0, "background").setOrigin(0);
        this.createScene();
        this.input.setDefaultCursor(this.brushCursor);
    }

    createScene() {
        this.map.getObjectLayer("Fossils").objects.forEach((ob: TiledGameObject) => {
            var fossil = new Fossil(this, ob);
            fossil.on("pointerdown", () => {
                // First time they touch it make it appear
                if(fossil.alpha < 1) {
                    fossil.setAlpha(1);
                }
                else {
                    fossil.dig();
                    this.checkGameEnd();
                }
            });
            this.fossils.push(fossil);
        });

        var bucketStuff = this.add.image(0, 0, "assets", "decoration").setOrigin(0);
    }

    endGame(): void {
        this.input.setDefaultCursor("default");
        this.input.enabled = false;
        this.scene.add("EndGameScene", EndGameScene, true);
        this.scene.remove(this);
    }

    checkGameEnd() {
        for (var fossil of this.fossils) {
            if (!fossil.dug) {
                return false;
            }
        }

        setTimeout(() => {
            this.endGame();
        }, 1200);
    }
}



// WEBPACK FOOTER //
// ./src/games/FossilFinderGame/scenes/MainScene.ts